function composeEventHandlers(originalEventHandler, ourEventHandler) {
  let {
    checkForDefaultPrevented = true
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return event => {
    originalEventHandler == null ? void 0 : originalEventHandler(event);

    if (checkForDefaultPrevented === false || !event.defaultPrevented) {
      ourEventHandler == null ? void 0 : ourEventHandler(event);
    }
  };
}

export { composeEventHandlers };